import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { removeDestination, setBacEmpty, setBacClean, setDestination,
   setIsBatch, setCodeFormats } from '../redux/actions';
import { getDestination, getBacEmpty, getBacClean, getIsBatch, getCodeFormats
} from '../redux/selectors';


// bac_empty services

/** Set bac_empty */
export const useSetBacEmpty = () => {
  const dispatch = useDispatch();
  return bacEmpty => dispatch(setBacEmpty(bacEmpty)); 
}

/** Get bac_empty */
export const useGetBacEmpty = () => {
  return useSelector(state => getBacEmpty(state.rootReducer))
}


// bac_clean services

/** Set bac_clean */
export const useSetBacClean = () => {
  const dispatch = useDispatch();
  return bacClean => dispatch(setBacClean(bacClean)); 
}

/** Get bac_clean */
export const useGetBacClean = () => {
  return useSelector(state => getBacClean(state.rootReducer))
}


// isBatch services

/** Set isBatch */
export const useSetIsBatch = () => {
  const dispatch = useDispatch();
  return isBatch => dispatch(setIsBatch(isBatch)); 
}

/** Get isBatch */
export const useGetIsBatch = () => {
  return useSelector(state => getIsBatch(state.rootReducer))
}


// Destination services

/** Set the destination. */
export function useSetDestination() {
  const dispatch = useDispatch();
  return (place) => dispatch(setDestination(place));
}

/** Remove the destination. */
export function useRemoveDestination() {
  const dispatch = useDispatch();
  return () => dispatch(removeDestination());
}

/** Get the current destination. */
export function useGetDestination() {
  return useSelector(state => getDestination(state.rootReducer))
}


//Code formats services

/** Set the code formats. */
export const useSetCodeFormats = () => {
  const dispatch = useDispatch();
  return codeFormats => dispatch(setCodeFormats(codeFormats)); 
}

/** Get the code formats. */
export const useGetCodeFormats = () => {
  return useSelector(state => getCodeFormats(state.rootReducer))
}

/** Get the code regexes. */
export const useGetRegexes = () => {
  const codeFormats = useGetCodeFormats();
  return useMemo(() => codeFormats.map(c => new RegExp(c.pattern)), [])
}
